import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export function useModalManager(onModalToggle) {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const location = useLocation();

  const toggleAuthModal = () => setShowAuthModal(!showAuthModal);

  const toggleChangePasswordModal = () => {
    if (!showChangePasswordModal) {
      if (onModalToggle) onModalToggle();
    }
    setShowChangePasswordModal(!showChangePasswordModal);
  };

  const toggleAddUserdModal = () => {
    if (!showAddUserModal) {
      if (onModalToggle) onModalToggle();
    }
    setShowAddUserModal(!showAddUserModal);
  };

  useEffect(() => {
    if (location.pathname === "/signin" || location.pathname === "/resetpassword") {
      setShowAuthModal(true);
    } else {
      setShowAuthModal(false);
    }
  }, [location]);

  return {
    showAuthModal,
    showChangePasswordModal,
    showAddUserModal,
    toggleAuthModal,
    toggleChangePasswordModal,
    toggleAddUserdModal,
    setShowAddUserModal,
  };
}
